import get from 'lodash/get';
import omit from 'lodash/omit';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import CustomInput from './CustomInput';
import {ChevronDownIcon} from "../../styles/icons";

const defaultStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const getStates = () => defaultStates;

const handleChange = ({onChange}) => (e, obj) => {
  const value = get(obj, 'value', null) || null;
  onChange({target: {value}});
};

const StateSelect = props => {
  const {states,error,label,required,variant,onChange} = props;
  return (
    <CustomInput {...omit(props, 'children')}>
      <Autocomplete
        id='state-select'
        popupIcon={props.popupIcon ? props.popupIcon : <ChevronDownIcon />}
        options={states.map(s => ({label: s, value: s}))}
        defaultValue={props.defaultValue}
        renderInput={(params) => <TextField
          {...params}
          placeholder='Select State'
          variant={variant}
          required={required}
          InputLabelProps={{shrink: true}}
        />}
        error={error}
        onChange={handleChange({onChange})}
        style={{backgroundColor: '#ffffff'}}
      />
    </CustomInput>
  );
};

StateSelect.defaultProps = {
  states: defaultStates,
  error: null,
  required: true,
  variant: 'outlined',
  label: 'State',
};

export default StateSelect;
